var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { useState, useMemo } from "react";
import { useRem } from "../utils/global";
import LazyLoad from "../lazy-load";
import { Placeholder } from "./placeholder";
import "./image.css";
import { useCDN } from "./use-cdn";
var classPrefix = "bbt-react-image";

var Image = function (props) {
  var _a = props.fitMode,
      fitMode = _a === void 0 ? "fill" : _a,
      _b = props.lazyLoad,
      lazyLoad = _b === void 0 ? false : _b,
      _c = props.display,
      display = _c === void 0 ? "inline-block" : _c,
      _d = props.styles,
      styles = _d === void 0 ? {} : _d,
      className = props.className;

  var _e = useState(false),
      loaded = _e[0],
      setLoaded = _e[1];

  var _f = useState(false),
      failed = _f[0],
      setFailed = _f[1];

  var _g = useState(!lazyLoad),
      init = _g[0],
      setInit = _g[1];

  var usePx2rem = useRem(props === null || props === void 0 ? void 0 : props.px2rem);
  var width = useMemo(function () {
    return usePx2rem(props === null || props === void 0 ? void 0 : props.width);
  }, [props === null || props === void 0 ? void 0 : props.px2rem, props === null || props === void 0 ? void 0 : props.width]);
  var height = useMemo(function () {
    return usePx2rem(props === null || props === void 0 ? void 0 : props.height);
  }, [props === null || props === void 0 ? void 0 : props.px2rem, props === null || props === void 0 ? void 0 : props.height]);
  var src = useMemo(function () {
    return init ? props.src || undefined : undefined;
  }, [init, props.src]);
  var srcSet = useMemo(function () {
    return init ? props.srcSet || undefined : undefined;
  }, [init, props.srcSet]);
  var cdnSrc = useCDN({
    src: src,
    width: props === null || props === void 0 ? void 0 : props.width,
    height: props === null || props === void 0 ? void 0 : props.height,
    options: typeof (props === null || props === void 0 ? void 0 : props.qiniu) === "object" ? props === null || props === void 0 ? void 0 : props.qiniu : {},
    open: Boolean(props === null || props === void 0 ? void 0 : props.qiniu)
  })[0];
  var PlaceholderRender = useMemo(function () {
    return React.createElement("div", {
      className: "".concat(classPrefix, "-placeholder"),
      style: {
        width: width,
        height: height
      }
    }, React.createElement(Placeholder, null));
  }, [width, height]);
  var placeholder = (props === null || props === void 0 ? void 0 : props.placeholder) || PlaceholderRender;
  var fallback = (props === null || props === void 0 ? void 0 : props.fallback) || PlaceholderRender;

  var RenderImg = function () {
    if (failed) {
      return fallback;
    }

    return React.createElement(React.Fragment, null, !loaded ? placeholder : null, React.createElement("img", {
      src: (props === null || props === void 0 ? void 0 : props.qiniu) ? cdnSrc : src,
      srcSet: srcSet,
      crossOrigin: props.crossOrigin,
      decoding: props.decoding,
      loading: props.loading,
      referrerPolicy: props.referrerPolicy,
      sizes: props.sizes,
      useMap: props.useMap,
      style: __assign({
        objectFit: fitMode,
        width: width,
        height: height
      }, styles),
      className: className,
      onClick: props.onClick,
      onLoad: function (e) {
        var _a;

        setLoaded(true);
        (_a = props.onLoad) === null || _a === void 0 ? void 0 : _a.call(props, e);
      },
      onError: function (e) {
        var _a;

        setFailed(true);
        (_a = props.onError) === null || _a === void 0 ? void 0 : _a.call(props, e);
      }
    }));
  };

  return React.createElement("div", {
    onClick: props.onContainerClick,
    style: {
      display: display,
      width: width,
      height: height
    },
    className: "".concat(classPrefix, " ").concat((props === null || props === void 0 ? void 0 : props.containerClassName) || "")
  }, lazyLoad && !init ? React.createElement(LazyLoad, {
    onVisible: function (visible) {
      visible && setInit(visible);
    },
    container: (props === null || props === void 0 ? void 0 : props.container) || null
  }, React.createElement("div", {
    style: {
      width: "1px",
      height: "1px"
    }
  })) : RenderImg());
};

Image.options = null;

Image.use = function (options) {
  if (options) {
    Image.options = options;
  }
};

export { Image };